import React from "react"
import CallStyles from "./CallUs.module.css"

const CallUs = () => {

  return (
    <div className={`${CallStyles.container}`}>
      <a href="tel:+918988988787" className={CallStyles.content}>
        <span
          className={CallStyles.text}
        >
          Call us at
        </span>
        <span
          className={CallStyles.number}
        >
          898 898 8787
        </span>
      </a>
    </div>
  )
}

export default CallUs;